import {PlainLink} from 'core/components/link'
import {ILuminopiaLogoVerticalTheme, LuminopiaLogoVertical} from 'core/components/LuminopiaLogo'
import {IFormFields, Register, registerFormFactory} from 'core/components/register'
import {routeProps} from 'core/utils/react-router-helpers'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {Redirect, RouteComponentProps, withRouter} from 'react-router'
import Card from 'study_reviewer/components/Card'
import * as routes from 'study_reviewer/routes'
import {IState, registerRequest} from 'study_reviewer/store'
import * as styles from './LoginPage.css'
import * as classNames from 'core/components/register/Register.css'

interface ITheme extends ILuminopiaLogoVerticalTheme {
  logoContainer?: string
  formContainer?: string
}

interface IStateProps {
  isLoggedIn: boolean
}
interface IDispatchProps {
}
interface IOwnProps extends RouteComponentProps<void> {}
interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

class RegisterConfirmPage extends React.Component<IProps, {}> {
  public render() {
    const {isLoggedIn} = this.props
    if (isLoggedIn) return this.redirectToReferrer()

    return (
      <div className={styles.page}>
        <Card>
          <Register
            {...routeProps<IProps, void>(this.props)}
            theme={{graphic: styles.graphic, lettering: styles.lettering}}
          />
          <h3 className={classNames.h3}>Thank you for registering!</h3>
          <p>Your account registeration is now being reviewed by Luminopia. 
            Once your account is approved you will receive a confirmation email, 
            at which point you will be able to login and review your patients.</p>
          <p>If you have any questions, please contact us at <a href="mailto:support@luminopia.com"> support@luminopia.com</a></p>
        </Card>
        <Card>
          <PlainLink className={styles.link} to={routes.publicSiteRoute()} 
          target="_blank">Visit <u>Luminopia.com</u>
          </PlainLink>
        </Card>
      </div>
    )
  }

  private redirectToReferrer() {
    const from = this.props.location.state && this.props.location.state.from
    if (!from || from.pathname === routes.loginRoute() || from.pathname === routes.logoutRoute()) {
      return <Redirect to={routes.loginRoute()} />
    }
    return <Redirect to={from} />
  }
}

const mapStateToProps = (state: IState): IStateProps => ({
  isLoggedIn: !!state.login.token,
})

export default withRouter(
  connect<IStateProps, IDispatchProps, IOwnProps, IState>(mapStateToProps)(RegisterConfirmPage),
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/pages/RegisterConfirmPage.tsx